import React from 'react'

import './ContactPage.css'

import { Fade} from 'react-animated-components'
import ContactForm from '../../components/contact/contact'

import img from '../../images/contact-img.svg';

export default function ContactPage() {
  return (
    <Fade
      ref={{
        current: '[Circular]'
      }}
      onActive={function noRefCheck(){}}
      onComplete={function noRefCheck(){}}
    >
      <div className='ContactPage'>
        <div className='ContactPageLeft'>
          <h2 className='ContactTitle'>
            Get <span>In</span> Touch!
          </h2>
          <div className="ContactForm">
            <ContactForm/>
          </div>
        </div>
        <div className='ContactPageRight'>
          <img src={img} alt="contact-img"/>
        </div>
      </div>
    </Fade>
  )
}
